import { colors, fontSize, size } from "@styles/theme"
import { useAuthContext } from "@contexts/authContext"
import useModalContext from "@contexts/modalContext"
import styled from "@emotion/styled"

import { TbPhotoPlus } from 'react-icons/tb'
import { IconButton } from "@mui/material"

const ReplyBar = styled.div`
  display: flex;
  align-items: center;

  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 1000;
  
  height: ${size(5)};
  width: 100%;
  padding: 0 ${size(1.5)};
  border-top: 0.5px solid rgba(47, 51, 54);
  
  background-color: rgba(0,0,0,0.8);
  backdrop-filter: blur(10px);
`

const ReplyInput = styled.input`
  width: 100%;
  padding: ${size(0.75)} 0 ${size(0.75)} 0;

  outline: none;
  border: none;
  border-bottom: 0.5px solid rgba(47, 51, 54);
  
  background-color: transparent;
  font-size: ${fontSize('sm')};

  ::placeholder {
    color: grey;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
`

const PostShowReplyInput = ({ post, newReplyAfterCreate }) => {
  const { newPost } = useModalContext()
  const { state: authState } = useAuthContext()
  const isAnonymous = authState?.user?.isAnonymous

  const openNewPost = ({ openMedia=false }) =>
    post && newPost.open(
      { search: { reply_to: post?.user?.handle, reply_id: post.uuid, open_media: openMedia, main_post_id: post?.uuid }},
      {},
      { afterCreate: newReplyAfterCreate }
    )
  
  const handleMediaClick = (e) => {
    e.stopPropagation()
    openNewPost({ openMedia: true })
  }

  if (isAnonymous) return;
  return (
    <ReplyBar onClick={() => openNewPost({ openMedia: false })}>
      <ReplyInput
        readOnly
        placeholder='Make reply'
      />
      <IconButton
        onClick={handleMediaClick}
        style={{
          position: 'absolute',
          right: size(1.5),
          transform: 'translateY(-50%)',
          top: '50%',
        }}>
        <TbPhotoPlus style={{ color: colors.statusColors.right_now('light'), opacity: 0.65 }} size={size(2.25)} />
      </IconButton>
    </ReplyBar>
  )
}

export { PostShowReplyInput }
